<template>
  <div
    class="width100"
    :class="['Padding', { inApp: $root.$data.isApp || this.$root.miniprogram }]"
  >
    <common-title titleName="优惠券" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <ul class="couponNav">
      <li
        :class="{ active: actind === ind }"
        v-for="(item, ind) in navList"
        :key="ind"
        @click="clickNav(ind)"
      >
        {{ item }}
      </li>
    </ul>
    <div class="couponList" v-show="isCouponList">
      <couponCard :actind="actind" />
    </div>
    <div v-show="!isCouponList">
      <div class="defaultImg">
        <img src="./img/couponDefault.png" alt />
        <p>还没有优惠券喔～</p>
      </div>
    </div>
    <Foot />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Foot from '@/components/foot/privacy.vue';
import couponCard from './couponCard.vue';
// import CommonTitle from '@/components/header/CommonTitle.vue';
import wx from 'weixin-js-sdk';

export default {
  components: {
    couponCard,
    Foot,
    // CommonTitle
  },
  data() {
    return {
      isCouponList: true,
      actind: 0,
      navList: ['未使用', '已使用', '已过期'],
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {},
  mounted() {
    this.toLogin();
  },
  methods: {
    clickNav(ind) {
      this.actind = ind;
    },
    // 去登录
    async  toLogin() {
      await this.$root.getUserInfo();
      if (this.userInfo?.id) return
      if (this.$root.$data.miniprogram) {
        let url = window.location.href;
        const [domain, searchParams] = url.split('?');
        if (searchParams) {
          const params = searchParams.split('&');
          const paramsMap = new Map();
          params.forEach((item) => {
            const [key, value] = item.split('=');
            if (key) {
              paramsMap.set(key, value);
            }
          });
          const entries = paramsMap.entries();
          let query = '';
          const ExcludequeryArr = ['THIRD_SESSION', 'env'];
          // eslint-disable-next-line no-restricted-syntax
          for (const [key, value] of entries) {
            if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
          }
          url = `${domain}?${query}`;
          const redirctUrl = encodeURIComponent(
            `/subPackages/myCoupon/index?url=${encodeURIComponent(url)}`,
          );
          const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
          wx.miniProgram.redirectTo({
            url: path,
          });
        }
      } else {
        this.$router.push({
          path: '/registrationLogin',
          query: { redirect: '/personalCenter/myCoupon' },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .common-foot {
  position: fixed;
}
.width100 {
  width: 100%;
}
.Padding {
  padding-top: 100px;
  padding-bottom: 100px;
  &.inApp {
    padding-top: 0;
  }
}
.defaultImg {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 290px;
  margin: 0 auto;
  img {
    display: block;
    width: 290px;
    height: 290px;
  }
  p {
    color: #787878;
    font-size: 25px;
    line-height: 36px;
  }
}
.couponNav {
  float: left;
  width: 100%;
  margin-bottom: 29px;
  padding: 0.38rem 0;
  background: #fff;
  li {
    position: relative;
    float: left;
    box-sizing: border-box;
    width: 33.33%;
    height: 0.34rem;
    color: #333;
    font-size: 0.39rem;
    text-align: center;
    border-right: 2px solid #e1e1e1;
  }
  li:last-child {
    border-right: 0 !important;
  }
  .active {
    color: #ff6c02;
    &::after {
      position: absolute;
      right: 0;
      bottom: -28px;
      left: 0;
      width: 45px;
      height: 5px;
      margin: 0 auto;
      background: #ff6c02;
      border-radius: 10px 10px 0 0;
      content: '';
    }
  }
}
.couponList {
  margin: 0 36px;
  padding-bottom: 1px;
}
</style>
